import { vars } from '@repo/config';
import type { ISessionApiResponse } from '../types/i-session-api-response';
import type { IUserSession } from '../types/i-user-session';
import { createGetFetchOptions } from './helper';
import { SessionServiceError } from './session-service-error';

interface IGetSessionServerOptions {
  throwOnServiceError?: boolean;
}

async function fetchSession(cookieHeader: string): Promise<IUserSession | null> {
  const sessionUrl = new URL('/api/auth/get-session', vars.url.identityUrl);
  const response = await fetch(sessionUrl.toString(), createGetFetchOptions({ cookieHeader }));

  if (response.status >= 500 || response.status === 429) {
    throw new SessionServiceError(`Identity get-session failed with status ${response.status}`);
  }

  if (!response.ok) {
    return null;
  }

  const data = (await response.json()) as ISessionApiResponse;

  if (!data.user) {
    return null;
  }

  return {
    ...(data.session || {}),
    user: data.user,
  };
}

export async function getSessionServer(
  cookieHeader: string,
  options?: IGetSessionServerOptions,
): Promise<IUserSession | null> {
  try {
    return await fetchSession(cookieHeader);
  } catch (error) {
    if (options?.throwOnServiceError) {
      throw error instanceof SessionServiceError
        ? error
        : new SessionServiceError('Identity get-session request failed', error);
    }
    return null;
  }
}
